module.exports = __webpack_public_path__ + "img/filter.aa13a27f.svg";